export default __webpack_public_path__ + "static/media/tape_measure.13bed14a.png";